module.exports = __webpack_public_path__ + "img/0e46963.jpg";